import { createContext, useContext, useEffect, useState } from "react";

const AudioContext = createContext(null);

export const AudioProvider = ({ children }) => {

  const [audioRef, setAudioRef] = useState(null);
  const [audioPlay, setAudioPlay] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioData, setAudioData] = useState({
    audio_id : "",
    title: "",
    author: "",
    reader: "",
    image: "",
    url: "",
    series: "",
    route: "",
  })

  // control popup state
  const [isPopUpRemove, setIsPopUpRemove] = useState(false);


  const pauseAudio = () => {
    setAudioPlay(false);
    audioRef?.current.pause();
  };

  const playAudio = () => {
    setAudioPlay(true);
    audioRef?.current.play();
  };

  // pause the audio when change music url
//   useEffect(() => {
//     console.log(audioUrl);
//     if(audioUrl) {
//         audioRef?.current.play();
//     }
//   }, [audioUrl]);


//   const toggleAudio = () => {
//         if (audioPlay) {
//             audioRef.current.pause();
//           } else {
//             audioRef.current.play();
//           }
//           setAudioPlay(!audioPlay);
//   };

  const toggleAudio = () => {
      if (audioPlay) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setAudioPlay(!audioPlay);
  };


  return (
    <AudioContext.Provider
      value={{
        audioRef,
        audioPlay,
        isPopUpRemove,
        audioData,
        audioUrl,
        setAudioUrl,
        setAudioData,
        setAudioRef,
        setAudioPlay,
        setIsPopUpRemove,
        playAudio,
        pauseAudio,
        toggleAudio
      }}
    >
      {children}
    </AudioContext.Provider>
  );
};

export const useAudio = () => {
  return useContext(AudioContext);
};
